import React, { useRef } from 'react';
import { useMutation } from '@apollo/client';
import ScanPlateMutation from './ScanPlateMutation';

interface IScanPlateConnectorApolloProps {
  children: ({
    scanPlate,
    cancelScanPlate,
  }: {
    scanPlate: (image: File, imageContext: string) => Promise<unknown>;
    cancelScanPlate: () => void;
  }) => React.ReactElement;
}

const ScanPlateConnectorApollo: React.FC<IScanPlateConnectorApolloProps> = ({ children }) => {
  const [scanPlateMutation] = useMutation(ScanPlateMutation);
  const abortControllerRef = useRef<AbortController | null>(null);

  const scanPlate = async (image: File, imageContext: string) => {
    // Create new AbortController for this request
    abortControllerRef.current = new AbortController();

    const response = await scanPlateMutation({
      variables: { image, imageContext },
      context: {
        fetchOptions: {
          signal: abortControllerRef.current.signal,
        },
      },
    });

    return response.data?.dailyTracker?.scanPlate;
  };

  const cancelScanPlate = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }
  };

  return children({ scanPlate, cancelScanPlate });
};

export default ScanPlateConnectorApollo;
